import { useState, useEffect } from 'react';
import { reviewService } from '@/services/review';

/**
 * 리뷰 통계 계산 훅
 * 매장의 실제 리뷰 데이터에서 평균 평점과 총 리뷰 개수를 계산합니다.
 * 데이터베이스의 restaurant 테이블에 저장된 값 대신 실시간으로 계산된 정확한 값을 제공합니다.
 */
export function useReviewStats(restaurantId: string | null) {
  const [calculatedRating, setCalculatedRating] = useState<number>(0);
  const [calculatedTotalReviews, setCalculatedTotalReviews] = useState<number>(0);
  const [isLoadingReviewStats, setIsLoadingReviewStats] = useState(false);

  useEffect(() => {
    if (!restaurantId) {
      setCalculatedRating(0);
      setCalculatedTotalReviews(0);
      return;
    }

    const calculateReviewStats = async () => {
      try {
        setIsLoadingReviewStats(true);
        const reviews = await reviewService.getReviewsByRestaurant(restaurantId);
        
        // getReviewsByRestaurant는 이미 active 리뷰만 반환하고 평점도 변환됨 (DB 1-10 → UI 0.5-5.0)
        const totalReviews = reviews.length;
        const avgRating = totalReviews > 0 
          ? reviews.reduce((sum, review) => sum + review.rating, 0) / totalReviews 
          : 0;
        
        setCalculatedTotalReviews(totalReviews);
        setCalculatedRating(avgRating);
        
        console.log('Review stats calculated:', { restaurantId, totalReviews, avgRating, reviews });
      } catch (error) {
        console.error('Failed to calculate review stats:', error);
        setCalculatedTotalReviews(0);
        setCalculatedRating(0);
      } finally {
        setIsLoadingReviewStats(false);
      }
    };

    calculateReviewStats();
  }, [restaurantId]);

  return {
    calculatedRating,
    calculatedTotalReviews,
    isLoadingReviewStats
  };
}